import {eventIdTrackingEventGenerate} from "../../utils/appUtils";

export function trackFacebookEvent(eventName: string, data: any) {
	const eventId = eventIdTrackingEventGenerate(eventName);
	if (window.fbq) {
		window.fbq('track', eventName, data, { eventID: eventId });
	}
}

export function trackTiktokEvent(eventName: string, data: any) {
	const eventId = eventIdTrackingEventGenerate(eventName);
	if (window.ttq) {
		window.ttq.track(eventName, data, { eventID: eventId });
	}
}
